<script lang="ts">
    import { onMount } from 'svelte';
    import { experimentService } from '$lib/services/experiment';

    import type { StoryFeedItem } from '@api/story/types';
    import type { Experiment } from '@api/types';
    import { JsonLd, type JsonLdData } from '@components/common/json-ld';
    import { getAlternativeContent } from '@components/public/alternative/functions';
    import { AlternativeInfoBlock, type AlternativeInfoBlockContent } from '@components/public/alternative/info-block';
    import { type MainGenderBlockContent, MainGenderBlockStories, MainWrapper } from '@components/public/main';
    import type { PageMeta } from '@components/types';
    import LL from '@i18n/i18n-svelte';
    import { Competitor } from '@shared/route-types';

    import { page } from '$app/stores';

    export let data: {
        competitor: Competitor;
        stories: StoryFeedItem[];
        experiment: Experiment | null;
        jsonLd: JsonLdData | null;
    };

    let content: {
        meta: PageMeta;
        genderBlockContent: MainGenderBlockContent;
        infoBlockContent: AlternativeInfoBlockContent;
    } | null = null;
    $: content = data.competitor ? getAlternativeContent($LL, data.competitor) : null;

    let otherCompetitors: Competitor[] = [];
    $: otherCompetitors = Object.values(Competitor).filter(c => c !== data?.competitor) as Competitor[];

    const currentUrl = new URL($page.url.href);
    const cleamImageUrl = currentUrl.origin.endsWith('/')
        ? currentUrl.origin.slice(0, -1)
        : currentUrl.origin;

    onMount(() => {
        if (data.experiment) {
            experimentService.mergeCookiesAndConfig({
                isUserExist: false,
                experiments: [data.experiment],
            });
        }
    });

    $: jsonLdData = data.jsonLd && {
        headline: content?.genderBlockContent.title,
        description: content?.meta?.description,
        image: content?.infoBlockContent ? [
            `${cleamImageUrl}${content.infoBlockContent.why.article1.imgSrc}`,
            `${cleamImageUrl}${content.infoBlockContent.why.article2.imgSrc}`,
            `${cleamImageUrl}${content.infoBlockContent.why.article3.imgSrc}`,
            `${cleamImageUrl}${content.infoBlockContent.why.article4.imgSrc}`,
        ] : undefined,
        ...data.jsonLd,
    };

</script>

<svelte:head>
    <title>{content?.meta?.title}</title>
    <meta name="description" content={content?.meta?.description} />
    <meta property="og:image" content={content?.meta?.ogImage} />
</svelte:head>
<JsonLd data={jsonLdData} />

{#if content}
    <MainWrapper>
        <MainGenderBlockStories stories={data.stories} content={content.genderBlockContent} isFakeOnline />
        <AlternativeInfoBlock content={content.infoBlockContent} competitor={data.competitor} {otherCompetitors} />
    </MainWrapper>
{/if}
